// extracted by mini-css-extract-plugin
export default {"wrapper":"TableSlice_wrapper__2wYZw","footer":"TableSlice_footer__gdVuu","alignCenter":"TableSlice_alignCenter__4wUOX","alignLeft":"TableSlice_alignLeft__6IQSe"};